import React from 'react'
import PropTypes from 'prop-types'
import {BodyCopy as HecBodyCopy} from '@/components/ui/body-copy'

const BodyCopy = ({content, size, attributes}) => {
    return (
        <HecBodyCopy size={size} {...attributes} data-testid="body-copy-HecBodyCopy">
            {content}
        </HecBodyCopy>
    )
}

export default BodyCopy

BodyCopy.propTypes = {
    content: PropTypes.string.isRequired,
    size: PropTypes.string,
    attributes: PropTypes.object
}

export const BodyCopyDefinition = {
    component: BodyCopy,
    name: 'Body Copy',
    noWrap: true,
    inputs: [
        {
            name: 'size',
            type: 'string',
            enum: ['large', 'medium', 'small'],
            defaultValue: 'large'
        },
        {
            name: 'content',
            type: 'longText',
            defaultValue: 'Body Copy'
        }
    ]
}
